module.exports = __webpack_public_path__ + "img/cloudThirdBg.654f40f8.png";